import React, { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import avatarBlank from 'assets/images/avatar-blank.png';
import Icon from 'components/Icon';
import Portal from 'components/Portal';
import Button from 'components/Button';

import { userLogout } from '@api/auth';
import { authLogoutAction } from '@services/user/actions';
import { resetCalendarAction } from '@services/calendar/actions';
import { resetCartAction } from '@services/cart/actions';
import { resetMenuAction } from '@services/menu/actions';
import { resetSettingAction } from '@services/setting/actions';

import { Menu, Nav, NavItem, Close, OpenButton, Header } from './style';

const UserMenu = ({ profile: { firstName, lastName, mobile, image } }) => {
	const dispatch = useDispatch();
	const show = useRef(false);
	const ref = useRef();
	const toggle = useCallback(() => {
		if (show.current) {
			ref.current.classList.remove('show');
		} else {
			ref.current.classList.add('show');
		}
		show.current = !show.current;
	}, []);

	const onLogout = useCallback(() => {
		userLogout();
		dispatch(authLogoutAction());
		dispatch(resetCalendarAction());
		dispatch(resetCartAction());
		dispatch(resetMenuAction());
		dispatch(resetSettingAction());
		toggle();
	}, []);

	return (
		<>
			<OpenButton onClick={toggle}>
				<Icon name='menu' />
			</OpenButton>

			<Portal>
				<Menu ref={ref}>
					<div
						className='lightbox'
						onClick={toggle}
						onKeyPress={toggle}
						role='button'
						tabIndex='0'
					/>

					<div className='inner'>
						<Close onClick={toggle}>
							<Icon name='cross' />
						</Close>

						<Header>
							<figure>
								<img
									src={image || avatarBlank}
									alt={`${firstName} ${lastName}`}
								/>
							</figure>

							<aside>
								<h4>
									<div>
										{firstName} {lastName}
									</div>
									<small>{mobile}</small>
								</h4>
							</aside>
						</Header>

						<Nav>
							<NavItem $btn>
								<Button to='/menu' onClick={toggle}>
									سفارش غذا
								</Button>
							</NavItem>
							<NavItem>
								<Link to='/user/info' onClick={toggle}>
									<Icon name='user' />
									تنظیمات پروفایل
								</Link>
							</NavItem>
							<NavItem>
								<Link to='/user/change-password' onClick={toggle}>
									<Icon name='lock' />
									تغییر رمز عبور
								</Link>
							</NavItem>
							{/* <NavItem><Link to='/'>
								<Icon name='calendar' />
								برنامه هفتگی غذایی
							</Link></NavItem> */}
							<NavItem>
								<Link to='/user/feedback' onClick={toggle}>
									<Icon name='feedback' />
									بازخوردهای من
								</Link>
							</NavItem>
							<NavItem>
								<Link to='/user/order' onClick={toggle}>
									<Icon name='orders' />
									سفارشات من
								</Link>
							</NavItem>
							<NavItem>
								<Link to='/user/transactions' onClick={toggle}>
									<Icon name='orders' />
									گزارشات مالی
								</Link>
							</NavItem>
							{/* <NavItem>
								<a href='https://www.nahartime.com' className='angle-right'>
									<Icon name='angle-right' />
									صفحه اصلی
								</a>
							</NavItem> */}
							<NavItem>
								<button onClick={onLogout} type='button'>
									<Icon name='logout' />
									خروج
								</button>
							</NavItem>
						</Nav>
					</div>
				</Menu>
			</Portal>
		</>
	);
};

export default UserMenu;
